module.exports = __webpack_public_path__ + "media/images/map/yellow-204a3e69e1cfe421ec1fc5379c2c0cc2.svg";